import React, { useState, useEffect } from "react";
import Button from "../../Components/Button";
import { supabase } from "../../supabaseClient";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";

const LanguageForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [languageName, setLanguageName] = useState("");
  const [loading, setLoading] = useState(false);
  const [originalLanguage, setOriginalLanguage] = useState("");


  useEffect(() => {
    if (id) {
      setLoading(true);
      supabase
        .from("languages")
        .select("languages")
        .eq("id", id)
        .single()
        .then(({ data, error }) => {
          if (error || !data) {
            // alert("Failed to load language");
            Swal.fire({
              position: "top-end", // top-right corner
              icon: "error", // success, error, warning, info
              title: "Failed to load language", // your message
              showConfirmButton: false, // no OK button
              timer: 3000, // auto close after 3 seconds
              timerProgressBar: true, // shows a progress bar
              toast: true, // makes it a toast
              background: "white", // optional, Tailwind prefers light bg
              customClass: {
                popup: "shadow-lg rounded-md p-3", // Tailwind classes
              },
            });
            navigate("/languages");
          } else {
            // setLanguageName(data.languages);
            setLanguageName(data.languages);
            setOriginalLanguage(data.languages); // 👈 store original

          }
          setLoading(false);
        });
    }
  }, [id, navigate]);

  const handleSave = async (e) => {
    e.preventDefault();

    if (!languageName.trim()) {
      // alert("Please enter a language name");
      Swal.fire({
        position: "top-end", // top-right corner
        icon: "warning", // success, error, warning, info
        title: "Please enter a language name", // your message
        showConfirmButton: false, // no OK button
        timer: 3000, // auto close after 3 seconds
        timerProgressBar: true, // shows a progress bar
        toast: true, // makes it a toast
        background: "white", // optional, Tailwind prefers light bg
        customClass: {
          popup: "shadow-lg rounded-md p-3", // Tailwind classes
        },
      });
      return;
    }

    setLoading(true);


    const normalized = languageName.trim().toLowerCase();

    // 🔹 ADD MODE — block duplicates
    if (!id) {
      const { data: existing } = await supabase
        .from("languages")
        .select("id")
        .ilike("languages", normalized);

      if (existing && existing.length > 0) {
        setLoading(false);
        Swal.fire({
          position: "top-end",
          icon: "error",
          title: `"${languageName}" already exists`,
          showConfirmButton: false,
          timer: 3000,
          toast: true,
          background: "white",
        });
        return;
      }
    }

    // 🔹 EDIT MODE
    if (id) {
      const originalNormalized = originalLanguage.trim().toLowerCase();

      // ✅ If name NOT changed → skip duplicate check entirely
      if (normalized !== originalNormalized) {
        const { data: existing } = await supabase
          .from("languages")
          .select("id")
          .ilike("languages", normalized)
          .neq("id", id); // exclude self

        if (existing && existing.length > 0) {
          setLoading(false);
          Swal.fire({
            position: "top-end",
            icon: "error",
            title: `"${languageName}" already exists`,
            showConfirmButton: false,
            timer: 3000,
            toast: true,
            background: "white",
          });
          return;
        }
      }
    }

    if (id) {
      // Update existing language
      const { error } = await supabase
        .from("languages")
        .update({ languages: languageName.trim() })
        .eq("id", id);
      setLoading(false);

      if (error) {
        // alert("Failed to update language");
        Swal.fire({
          position: "top-end", // top-right corner
          icon: "error", // success, error, warning, info
          title: "Failed to update language", // your message
          showConfirmButton: false, // no OK button
          timer: 3000, // auto close after 3 seconds
          timerProgressBar: true, // shows a progress bar
          toast: true, // makes it a toast
          background: "white", // optional, Tailwind prefers light bg
          customClass: {
            popup: "shadow-lg rounded-md p-3", // Tailwind classes
          },
        });
      } else {
        // alert("Language updated successfully");
        Swal.fire({
          position: "top-end", // top-right corner
          icon: "success", // success, error, warning, info
          title: "Language updated successfully", // your message
          showConfirmButton: false, // no OK button
          timer: 3000, // auto close after 3 seconds
          timerProgressBar: true, // shows a progress bar
          toast: true, // makes it a toast
          background: "white", // optional, Tailwind prefers light bg
          customClass: {
            popup: "shadow-lg rounded-md p-3", // Tailwind classes
          },
        });
        navigate("/languages");
      }
    } else {
      // Insert new language
      const { error } = await supabase
        .from("languages")
        .insert([{ languages: languageName.trim() }]);
      setLoading(false);

      if (error) {
        // alert("Failed to add language");
        Swal.fire({
          position: "top-end", // top-right corner
          icon: "error", // success, error, warning, info
          title: "Failed to add language", // your message
          showConfirmButton: false, // no OK button
          timer: 3000, // auto close after 3 seconds
          timerProgressBar: true, // shows a progress bar
          toast: true, // makes it a toast
          background: "white", // optional, Tailwind prefers light bg
          customClass: {
            popup: "shadow-lg rounded-md p-3", // Tailwind classes
          },
        });
      } else {
        // alert("Language added successfully");
        Swal.fire({
          position: "top-end", // top-right corner
          icon: "success", // success, error, warning, info
          title: "Language added successfully", // your message
          showConfirmButton: false, // no OK button
          timer: 3000, // auto close after 3 seconds
          timerProgressBar: true, // shows a progress bar
          toast: true, // makes it a toast
          background: "white", // optional, Tailwind prefers light bg
          customClass: {
            popup: "shadow-lg rounded-md p-3", // Tailwind classes
          },
        });
        navigate("/languages");
      }
    }
  };



  return (
    <div className="min-h-screen flex flex-col p-6 bg-gray-50">
      <div className="mb-6">
        <Button
          variant="secondary"
          className="flex items-center gap-2 px-4 py-2"
          onClick={() => navigate(-1)}
        >
          <span className="text-lg">←</span> Back
        </Button>
      </div>

      <div className="flex-grow flex items-center justify-center">
        <form
          onSubmit={handleSave}
          className="space-y-6 max-w-md w-full bg-white border border-gray-300 rounded-md p-8 shadow-md"
        >
          <h1 className="text-3xl font-bold text-center text-gray-800">
            {id ? "Edit Language" : "Add Language"}
          </h1>

          <div>
            <label
              htmlFor="languageName"
              className="block mb-2 font-semibold text-gray-700"
            >
              Enter language name
            </label>
            <input
              id="languageName"
              name="languageName"
              type="text"
              value={languageName}
              onChange={(e) => setLanguageName(e.target.value)}
              placeholder="Enter language name"
              autoFocus
              className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
              disabled={loading}
            />
          </div>

          <div className="flex justify-center gap-4">
            <Button
              variant="primary"
              type="submit"
              disabled={loading}
              className="px-8 py-3 font-semibold text-lg"
            >
              {loading ? "Saving..." : id ? "Update" : "Save"}
            </Button>

            <Button
              variant="secondary"
              onClick={() => navigate("/languages")}
              className="px-8 py-3 font-semibold text-lg"
              disabled={loading}
            >
              Cancel
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LanguageForm;
